/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetUnproxiedMcpServerClientUsage } from "../funcs/telemetryGetUnproxiedMcpServerClientUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetUnproxiedMcpServerClientUsageResult } from "../models/components/getunproxiedmcpserverclientusageresult.js";
import {
  GetUnproxiedMcpServerClientUsageRequest,
  GetUnproxiedMcpServerClientUsageSecurity,
} from "../models/operations/getunproxiedmcpserverclientusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUnproxiedMcpServerClientUsageQueryData =
  GetUnproxiedMcpServerClientUsageResult;

export function prefetchGetUnproxiedMcpServerClientUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUnproxiedMcpServerClientUsageRequest,
  security?: GetUnproxiedMcpServerClientUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUnproxiedMcpServerClientUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUnproxiedMcpServerClientUsageQuery(
  client$: GramCore,
  request: GetUnproxiedMcpServerClientUsageRequest,
  security?: GetUnproxiedMcpServerClientUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUnproxiedMcpServerClientUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetUnproxiedMcpServerClientUsage({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getUnproxiedMcpServerClientUsageQueryFn(
      ctx,
    ): Promise<GetUnproxiedMcpServerClientUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetUnproxiedMcpServerClientUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUnproxiedMcpServerClientUsage(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "telemetry",
    "getUnproxiedMcpServerClientUsage",
    parameters,
  ];
}
